export const ValidatePostalCode = angular
    .module('checkout.filters.validatePostalCode', [])
    .directive('validatePostalCode', () => {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: (scope, element, attrs, ngModelCtrl) => {
                ngModelCtrl.$validators.validPostalCode = (modelValue, viewValue) => {
                    var value = modelValue || viewValue;
                    if (value == null || value === '') return true;
                    return /^\d{5}(?:[-\s]\d{4})?$/.test(value);
                };
            }
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/directives/validatePostalCode.js